module.exports = __webpack_public_path__ + "img/spirit_of_ember.f98de049.png";